import { render, staticRenderFns } from "./BnForgalmiBetukod.vue?vue&type=template&id=1d8890a2&scoped=true&"
import script from "./BnForgalmiBetukod.vue?vue&type=script&lang=js&"
export * from "./BnForgalmiBetukod.vue?vue&type=script&lang=js&"
import style0 from "./BnForgalmiBetukod.vue?vue&type=style&index=0&id=1d8890a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8890a2",
  null
  
)

export default component.exports